<template>
    <div id="interactive-house" class="mt-20 lg:mt-0" style="display:none;">
        <p class="mt-10 font-helvetica leading-5 text-lg text-co-dark-grey">Search the house to see where CO can be found and find out how to prevent a leak.</p>
        <p class="md:-mb-20 lg:-mb-32 font-helvetica leading-5 text-lg text-co-dark-grey">Tip: Hover over the places where flames can be found around the home.</p>

        <div class="interactive-house relative mx-auto -mt-10 md:-mt-32 lg:-mt-48 xl:-mt-64">

            <img src="/assets/img/interactive-house/house.svg" alt="Interactive house" class="mb-6 md:mb-0">

            <div v-for="element in house_elements" :key="element.id">

                <img :src="element.img" :alt="element.name.replace(/<br>/g, ' ')"
                    :class="[element.slug, 'house-element absolute']"
                    v-popover.left="{name: element.slug }">

                <popover :name="element.slug" event="hover" :class="`${element.slug}-popover`">
                    <div class="relative animate__animated animate__fadeIn font-permanent_marker">
                        <div class="interactive-house-large-circle border-white rounded-full py-10 md:py-20 px-6 overflow-hidden bg-no-repeat"
                             :class="element.class">

                            <h2 class="w-1/2 text-center text-2xl md:text-4xl text-white" v-html="element.name"></h2>
                        </div>

                        <div class="interactive-house-small-circle absolute flex justify-center items-center border-white rounded-full overflow-hidden">
                            <div class="px-4 lg:px-8 text-white text-xs md:text-sm lg:text-xl">
                                <ul class="pl-5 " v-html="element.desc"></ul>
                            </div>
                        </div>
                    </div>
                </popover>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            house_elements: [
                {
                  id: 1,
                  class: 'chimney',
                  name: 'The<br>Chimney',
                  slug: 'chimney',
                  img: '/assets/img/interactive-house/chimney.svg',
                  desc: '<li class="list-none text-xl">Sweep your chimney once a year</li>'
                },
                {
                  id: 2,
                  class: 'boiler',
                  name: 'The<br>Boiler',
                  slug: 'boiler',
                  img: '/assets/img/interactive-house/boiler.svg',
                  desc: '<li class="mb-2 list-none">Get it serviced once a year by a certified engineer</li><li class="list-none text">If flames are orange, switch off and seek professional help.</li>'
                },
                {
                  id: 3,
                  class: 'heater',
                  name: 'The<br>Heater',
                  slug: 'heater',
                  img: '/assets/img/interactive-house/heater.svg',
                  desc: '<li class="list-none text-xl">Get it serviced once a year by a certified engineer</li>'
                },
                {
                  id: 4,
                  class: 'bbq',
                  name: 'The<br>BBQ',
                  slug: 'bbq', img: '/assets/img/interactive-house/bbq.svg',
                  desc: '<li class="list-none text-xl">Never bring inside</li>'
                },
                {
                  id: 5,
                  class: 'cooker',
                  name: 'The<br>Cooker',
                  slug: 'cooker',
                  img: '/assets/img/interactive-house/cooker.svg',
                  desc: '<li class="list-none text-xl">If flames are orange, switch off and seek professional help.</li>'
                },
                {
                  id: 6,
                  class: 'fireplace',
                  name: 'The<br>Fireplace',
                  slug: 'fireplace',
                  img: '/assets/img/interactive-house/fireplace.svg?123',
                  desc: '<li class="list-none text-xl">Get it serviced once a year by a certified engineer</li>'
                }
            ]
        }
    },
}
</script>

<style lang="scss">
    [v-cloak] { display: none; }
    .interactive-house {
        /*max-width: 327px;*/

        @screen md {
            max-width: none;
            margin-bottom: -96.8%;
        }

        @screen lg {
            margin-bottom: -72.1%;
        }

        @screen xl {
            margin-bottom: -57.8%;
        }

        .vue-popover {
            top: -38% !important;
            left: 2rem !important;
            background: transparent;
            box-shadow: none;
            padding: 0;

            @screen md {
                top: 30% !important;
            }

            &:before {
                display: none;
            }

            .interactive-house-large-circle, .interactive-house-small-circle {
                background-color: #006FB9;
                border-width: 9px;
            }

            .interactive-house-large-circle {
                width: 250px;
                height: 250px;
                background-position: 4.5rem;

                &.chimney {
                    background-image: url('/assets/img/interactive-house/chimney.svg');
                }

                &.boiler {
                    background-image: url('/assets/img/interactive-house/boiler.svg');
                }

                &.heater {
                    background-image: url('/assets/img/interactive-house/heater.svg');
                }

                &.bbq {
                    background-image: url('/assets/img/interactive-house/bbq.svg');
                }

                &.cooker {
                    background-image: url('/assets/img/interactive-house/cooker.svg');
                }

                &.fireplace {
                    background-image: url('/assets/img/interactive-house/fireplace.svg?123');
                }

                @screen md {
                    width: 340px;
                    height: 340px;
                }

                @screen lg {
                    width: 440px;
                    height: 440px;
                }
            }

            .interactive-house-small-circle {
                width: 190px;
                height: 190px;
                bottom: -4rem;
                left: -3rem;

                @screen md {
                    width: 190px;
                    height: 190px;
                    bottom: -2.5rem;
                }

                @screen lg {
                    width: 275px;
                    height: 275px;
                    bottom: -1.5rem;
                    left: -6rem;
                }

                p {
                    @apply .my-0;
                }
            }

            &.heater-popover {
                .interactive-house-large-circle {
                    background-size: 130px;
                    background-position: right;

                    @screen md {
                        background-size: 170px;
                        background-position-x: right;
                    }

                    @screen lg {
                        background-size: 206px;
                        background-position-x: right;
                    }
                }
            }

            &.bbq-popover {
                .interactive-house-large-circle {
                    background-size: 130px;
                    background-position: right;

                    @screen md {
                        background-size: 170px;
                        background-position-x: right;
                    }

                    @screen lg {
                        background-size: 206px;
                        background-position-x: right;
                    }
                }
            }

            &.cooker-popover {
                .interactive-house-large-circle {
                    background-size: 130px;
                    background-position: right;

                    @screen md {
                        background-size: 170px;
                        background-position-x: right;
                    }

                    @screen lg {
                        background-size: 206px;
                        background-position-x: right;
                    }
                }
            }

            &.fireplace-popover {
                .interactive-house-large-circle {
                    background-size: 130px;
                    background-position-x: right;

                    @screen md {
                        background-size: 170px;
                        background-position-x: right;
                    }

                    @screen lg {
                        background-size: 206px;
                        background-position-x: right;
                    }

                }
            }
        }
    }

    .house-element {
        -webkit-animation: 3s tada 2s;
        animation: 3s tada 2s;

        @screen lg {
            -webkit-animation: none;
            animation: none;
        }

        &:hover {
            -webkit-animation: headShake 2.5s;
            animation: headShake 2.5s;
        }
    }

    .chimney {
        width: 44%;
        top: 3.2%;
        right: 0%;

        @screen md {
            width: 300px;
            top: 5.4%;
            right: 1.4%;
        }

        @screen lg {
            width: 420px;
            top: 4.1%;
            right: 0.7%;
        }

        @screen xl {
            width: 500px;
            top: 6.5%;
            right: 2%;
        }
    }

    .boiler {
        width: 10.6%;
        top: 47%;
        right: 26.8%;

        @screen md {
            width: 80px;
            top: 46.8%;
            left: 62.4%;
        }

        @screen lg {
            width: 106px;
            top: 46.9%;
            left: 62.5%;
        }

        @screen xl {
            width: 139px;
            top: 47%;
            left: 62.25%;
        }
    }

    .heater {
        width: 8%;
        top: 61%;
        left: 56%;

        @screen md {
            width: 62px;
            top: 60.4%;
            left: 55.7%;
        }

        @screen lg {
            width: 81px;
            top: 60.7%;
        }

        @screen xl {
            width: 105px;
            top: 60.5%;
        }
    }

    .bbq {
        width: 10%;
        bottom: 5.4%;
        left: 9%;

        @screen md {
            width: 73px;
            left: 8.5%;
            bottom: 5%;
        }

        @screen lg {
            width: 97px;
            left: 9%;
        }

        @screen xl {
            width: 120px;
        }
    }

    .cooker {
        width: 12.6%;
        bottom: 8.7%;
        left: 40.8%;

        @screen md {
            width: 90px;
            left: 40.7%;
            bottom: 8.4%;
        }

        @screen lg {
            width: 123px;
            left: 40.9%;
        }

        @screen xl {
            width: 152px;
            left: 40.78%;
        }
    }

    .fireplace {
        width: 32px;
        bottom: 8%;
        right: 21.6%;

        @screen md {
            width: 69px;
            right: 21.6%;
            bottom: 8.2%;
        }

        @screen lg {
            width: 93px;
        }

        @screen xl {
            width: 116px;
            right: 21.75%;
        }
    }
</style>
